// Version : 1.0.0
// Author : AGALYA

const AddressExtraProofActionType = {
	/** ***************** UPDATE ADDRESS EXTRA PROOF START *********************** */
	UPDATE_ADDRESS_EXTRA_PROOF_START: 'update_address_extra_proof_start',
	UPDATE_ADDRESS_EXTRA_PROOF_SUCCESS: 'update_address_extra_proof_success',
	UPDATE_ADDRESS_EXTRA_PROOF_FAILURE: 'update_address_extra_proof_failure',
	UPDATE_ADDRESS_EXTRA_PROOF_RESPONSE_REST_START:
		'update_address_extra_proof_response_reset_start',
	UPDATE_ADDRESS_EXTRA_PROOF_RESPONSE_CHANGED: 'update_address_extra_proof_response_changed',
	/** ***************** UPDATE ADDRESS EXTRA PROOF END *********************** */
};

export default AddressExtraProofActionType;
